new Vue({
  delimiters: ["[[", "]]"], // change because vue and django using the same args
  el: "#app_home",
  data: {
    activeIndex: 1,
  },
  methods: {
    toggleShowcase(index) {
      this.activeIndex = index;
    },
  },
  mounted() {
    waitForElementToExist("#faixa-cupom").then((element) => {
      const faixCupom = document.querySelector(".faixa-cupom");

      if (faixCupom) {
        const formButton = document.querySelector(".faixa-cupom-form button");
        const spanElement = document.getElementById("valorParaCopiar");

        if (spanElement) {
          let newValue = spanElement.textContent.replace(/^\/\//, "");

          if (formButton) {
            formButton.addEventListener("click", (e) => {
              e.preventDefault();
              faixCupom.classList.add("active");
              formButton.textContent = "Copiado!";
              navigator.clipboard
                .writeText(newValue)
                .then(() => {})
                .catch((err) => {
                  console.error("Erro ao copiar: ", err);
                  alert("Erro ao copiar o valor.");
                });
            });
          }
        }
      }
    });
  },
});

//sliders
$(document).ready(function () {
  var bannerHomeFull = $(".home__banner");

  var optionsBannerHome = {
    swipeToSlide: true,
    touchThreshold: 100,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: false,
    infinite: false,
    mobileFirst: true,
    adaptiveHeight: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    slidesToShow: 1,
    speed: 300,
    cssEase: "cubic-bezier(0.39, 0.58, 0.15, 0.98)",
  };

  // Init banner
  function initBannerHome(el) {
    el.slick(optionsBannerHome);
  }

  bannerHomeFull.on("init", function (event, slick) {
    $(".banner-home").find(".banner-home__loading").hide();
    $(".slider-slick").css({
      visibility: "visible",
      opacity: "1",
    });
  });

  initBannerHome(bannerHomeFull);

  waitForElementToExist(".categories").then((element) => {
    $("#categories-home-carrousel").slick({
      arrows: false,
      infinite: false,
      autoplay: false,
      dots: false,
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 1000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 5,
          },
        },
      ],
    });
  });

  waitForElementToExist(".banner-product").then((element) => {
    $("#product-banner").slick({
      swipeToSlide: true,
      touchThreshold: 100,
      arrows: false,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: true,
          },
        },
      ],
    });

    // Prevenir redirecionamento ao clicar nas arrows do slick
    $(".banner-product").on(
      "click",
      ".slick-arrow, .slick-prev, .slick-next",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
      },
    );

    $("#product-banner").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        Blazy({
          selector: ".lazy-img",
          successClass: "loaded-img",
          success: function (element) {
            setTimeout(function () {
              var parent = element.previousSibling;
              try {
                parent.className = parent.className.replace(
                  /\bproduct-item__image--loading\b/,
                  "",
                );
              } catch (e) {}
            }, 200);
          },
        });
      },
    );
  });

  waitForElementToExist(".banner-triplo").then((element) => {
    $(".banner-triplo").slick({
      arrows: false,
      infinite: false,
      autoplay: false,
      dots: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick",
        },
      ],
    });
  });

  waitForElementToExist(".first-vitrine").then((element) => {
    const firstCarrousel = element.querySelector("#product_list");
    if (firstCarrousel) {
      $("#product_list").slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
              arrows: true,
            },
          },
        ],
      });

      $("#product_list").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          Blazy({
            selector: ".lazy-img",
            successClass: "loaded-img",
            success: function (element) {
              setTimeout(function () {
                var parent = element.previousSibling;
                try {
                  parent.className = parent.className.replace(
                    /\bproduct-item__image--loading\b/,
                    "",
                  );
                } catch (e) {}
              }, 200);
            },
          });
        },
      );
    }
  });

  waitForElementToExist(".faixa-comunicado").then((element) => {
    $(".faixa-comunicado__list").slick({
      arrows: false,
      swipeToSlide: true,
      touchThreshold: 100,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 100,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick",
        },
      ],
    });
  });

  waitForElementToExist(".banner-triple").then((element) => {
    $(".banner-triple").slick({
      swipeToSlide: true,
      touchThreshold: 100,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      mobileFirst: true,
      autoplay: false,
      speed: 100,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick",
        },
      ],
    });
  });

  waitForElementToExist(".categoria-nav-list").then((element) => {
    $(".categoria-nav-list").slick({
      swipeToSlide: true,
      touchThreshold: 100,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: false,
      infinite: false,
      mobileFirst: true,
      autoplay: false,
      speed: 100,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick",
        },
      ],
    });
  });

  waitForElementToExist(".banner-instagram").then((element) => {
    const bannerInstagram = element.querySelector(".banner-instagram__content");
    if (bannerInstagram) {
      $(".banner-instagram__content").slick({
        arrows: false,
        swipeToSlide: true,
        touchThreshold: 100,
        dots: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        rows: 2,
        slidesPerRow: 2,
        slidesToScroll: 1,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 6,
              rows: 1,
              slidesPerRow: 1,
            },
          },
        ],
      });
    }
  });

  waitForElementToExist(".home__faq").then((element) => {
    const faqItems = document.querySelectorAll(".home__faq--list-item");

    if (faqItems.length > 0) {
      faqItems.forEach((item) => {
        item.addEventListener("click", () => {
          item.classList.toggle("active");
        });
      });
    }
  });

  waitForElementToExist(".banner-instagram").then((element) => {
    const bannerInstagram = element.querySelector(".banner-instagram__content");
    if (bannerInstagram) {
      $(".banner-instagram__content").slick({
        arrows: false,
        swipeToSlide: true,
        touchThreshold: 100,
        dots: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 5,
            },
          },
        ],
      });
    }
  });

  waitForElementToExist(".second-vitrine").then((element) => {
    const firstCarrousel = element.querySelector("#product_list-2");
    if (firstCarrousel) {
      $("#product_list-2").slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
              arrows: true,
            },
          },
        ],
      });

      $("#product_list-2").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          Blazy({
            selector: ".lazy-img",
            successClass: "loaded-img",
            success: function (element) {
              setTimeout(function () {
                var parent = element.previousSibling;
                try {
                  parent.className = parent.className.replace(
                    /\bproduct-item__image--loading\b/,
                    "",
                  );
                } catch (e) {}
              }, 200);
            },
          });
        },
      );
    }
  });

  waitForElementToExist(".third-vitrine").then((element) => {
    const firstCarrousel = element.querySelector("#product_list");
    if (firstCarrousel) {
      $("#product_list").slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
              arrows: true,
            },
          },
        ],
      });

      $("#product_list").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          Blazy({
            selector: ".lazy-img",
            successClass: "loaded-img",
            success: function (element) {
              setTimeout(function () {
                var parent = element.previousSibling;
                try {
                  parent.className = parent.className.replace(
                    /\bproduct-item__image--loading\b/,
                    "",
                  );
                } catch (e) {}
              }, 200);
            },
          });
        },
      );
    }
  });

  waitForElementToExist(".product-destaque").then((element) => {
    var swiper = new Swiper(".group-images", {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto", // padrão mobile
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      },
      loop: true,
    });
  });

  waitForElementToExist(".product-ratings").then((element) => {
    const productRatings = element.querySelector(".product-ratings-list");
    if (productRatings) {
      $(".product-ratings-list").slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 100,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
              dots: false,
              adaptiveHeight: true,
              arrows: true,
              appendArrows: $(".product-ratings .group-arrow"),
            },
          },
        ],
      });

      $(".product-ratings-list").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          Blazy({
            selector: ".lazy-img",
            successClass: "loaded-img",
            success: function (element) {
              setTimeout(function () {
                var parent = element.previousSibling;
                try {
                  parent.className = parent.className.replace(
                    /\bproduct-item__image--loading\b/,
                    "",
                  );
                } catch (e) {}
              }, 200);
            },
          });
        },
      );
    }
  });

  waitForElementToExist(".banner-scroll").then((element) => {
    // no mobile o banner vira carrossel com dots; acima de 991 o slick se
    // desfaz (unslick) e o efeito sticky do desktop assume
    $(".banner-scroll-list").slick({
      swipeToSlide: true,
      touchThreshold: 100,
      arrows: false,
      dots: true,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick",
        },
      ],
    });

    (function () {
      var DESKTOP_MIN_WIDTH = 992;
      var wrapper = document.querySelector(".banner-scroll");
      var items = [];
      var medias = [];
      var observer = null;
      var activeIndex = -1;
      var resizeTimer;

      if (!wrapper) {
        return;
      }

      items = Array.prototype.slice.call(
        wrapper.querySelectorAll(".banner-scroll-item"),
      );
      medias = Array.prototype.slice.call(
        wrapper.querySelectorAll(".banner-scroll-media img"),
      );

      if (!items.length) {
        return;
      }

      function isDesktop() {
        return window.innerWidth >= DESKTOP_MIN_WIDTH;
      }

      function setActive(index) {
        if (index === activeIndex || index < 0) {
          return;
        }

        activeIndex = index;

        items.forEach(function (item, i) {
          item.classList.toggle("is-active", i === index);
        });

        medias.forEach(function (img, i) {
          img.classList.toggle("is-active", i === index);
        });
      }

      function clearActive() {
        activeIndex = -1;

        items.forEach(function (item) {
          item.classList.remove("is-active");
        });

        medias.forEach(function (img) {
          img.classList.remove("is-active");
        });
      }

      function connect() {
        if (observer) {
          return;
        }

        // a faixa central da tela decide qual texto esta em foco: como cada
        // item tem 100vh, sempre ha exatamente um item cruzando essa linha
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                setActive(items.indexOf(entry.target));
              }
            });
          },
          { rootMargin: "-50% 0px -50% 0px", threshold: 0 },
        );

        items.forEach(function (item) {
          observer.observe(item);
        });

        // estado inicial enquanto o observer nao dispara o primeiro callback
        setActive(0);
      }

      function disconnect() {
        if (!observer) {
          return;
        }

        observer.disconnect();
        observer = null;
      }

      function refresh() {
        if (isDesktop()) {
          connect();
          return;
        }

        // no mobile quem controla a passagem dos itens e o slick
        disconnect();
        clearActive();
      }

      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(refresh, 200);
      });

      refresh();
    })();
  });
});
